(ns dashboard.i18n.ja
  (:require
   [clojure.string :refer [capitalize]]
   [inflections.core :refer [pluralize plural]]))

(def ja
  {:yes "はい"
   :no "いええ"
   :none "なし"
   :time/hours "時間"
   :time/day "日付"
   :time/date "日付"
   :time/weekends "土日祝"
   :time/weekdays "平日"
   :time/today "今日"
   :time/tomorrow "明日"
   :time/yesterday "昨日"
   :time/week "週"
   :time/next-week "次の週"
   :time/previous-week "前の週"
   :time/month "月"
   :time/next-month "来月"
   :time/previous-month "先月"
   :time/year "年"
   :time/day-of-week "曜日"
   :time/day-of-month "日"

   :action/actions "アクション"
   :action/sign-in "ログイン"
   :action/sign-out "ログアウト"
   :action/save "保存"
   :action/add "追加"
   :action/add-fn (fn [object]
                    (str object "を追加"))
   :action/assign "割当"
   :action/assign-fn (fn [object]
                       (str object "を割り当てる"))
   :action/change "変化"
   :action/create "作成"
   :action/edit "編集"
   :action/cancel "キャンセル"
   :action/uncancel "キャンセル済み"
   :action/edit-fn (fn [object]
                     (str object "を編集"))
   :action/sync "同期"
   :action/update "更新"
   :action/download "ダウンロード"
   :action/filter "フィルター"
   :action/upload "アップロード"
   :action/previous "前"
   :action/next "次"
   :action/close "閉じる"
   :action/select "選択"
   :action/view "一覧"
   :action/view-fn (fn [object]
                     (str object "の一覧"))
   :action/details-fn (fn [object]
                        (str object "の詳細"))
   :action/upcoming-fn (fn [object]
                         (str "近日中の" object))
   :action/join "参加"
   :action/decline "辞退"
   :action/delete "削除"
   :action/delete-all "すべてを削除"
   :action/delete-fn (fn [object]
                       (str object "を削除"))
   :action/confirm "確認"
   :action/confirm-fn (fn [object]
                        (str object "を確認"))
   :action/export "エクスポート"
   :action/export-fn (fn [object]
                       (str object "のエクスポート"))
   :action/import "インポート"
   :action/import-fn (fn [object]
                       (str object "のインポート"))
   :action/message "メッセージ"
   :action/search "検索"
   :action/complete "完成"

   :non-ideal/page-under-construction "建設中のページ"
   :non-ideal/page-not-found "そのページは存在しません"
   :non-ideal/no-entries-to-show "表示するエントリはありません"
   :non-ideal/no-data "データがありません"
   :non-ideal/not-applicable "適用できません"
   :non-ideal/no-data-on-this-period "この期間のデータはありません"
   :non-ideal/no-data-on-this-granularity "指定された単位のデータはありません"
   :non-ideal/error-page-title "予期しないエラー"
   :non-ideal/error-page-description "予期しないエラーが発生しました。"

   :calendar "カレンダー"
   :calendar/name "名（英語)"
   :calendar/nameJp "名（日本語)"
   :calendar/status "ステータス"
   :calendar/tag "タグ"
   :calendar/tags "タグ"
   :calendar/color "色"
   :calendar/agenda-view "リスト表示"
   :calendar/month-view "月表示"
   :calendar/week-view "週表示"
   :calendar/day-view "日表示"

   :calendar.tag/id "タグのID"
   :calendar.tag/name "タグ名（英語)"
   :calendar.tag/nameJp "タグ名（日本語)"
   :calendar.tag/color "色"
   :calendar.status/id "ステータスのID"
   :calendar.status/name "ステータス名"
   :calendar.status/nameJp "ステータス名"
   :calendar.status/color "色"

   :route.title/loading "読み込み中"
   :route.title/login "ログイン"
   :route.title/demo "デモ"
   :route.title/home "ホーム"
   :route.title/reports "レポート"
   :route.title/calendars "予定"
   :route.title/shifts "シフト"
   :route.title/settings "設定"
   :route.title/profile "プロフィール"
   :route.title/account "アカウント"
   :route.title/password "パスワード"
   :route.title/notifications "通知"
   :route.title/organization "組織"
   :route.title/spaces "ブティック"
   :route.title/users "ユーザー"
   :route.title/employees "社員"
   :route.title/billing "請求"
   :route.title/teams "チーム"
   :route.title/roles "アカウント権限"
   :route.title/rooms "ルーム"
   :route.title/bookings "予約"
   :route.title/events "イベント"

   :notifications "通知"
   :settings "設定"
   :settings-fn (fn [object]
                  (str object "の設定"))
   :tags "タグ"
   :user-guide "ユーザーガイド"

   :home/upcoming-shifts "今後のシフト"
   :home/my-shifts-colleagues "今日のシフト"
   :filter/all-spaces "全てのブティック"
   :filter/all-titles "全ての役職名称"
   :filter/all-calendars "全てのカレンダー"
   :filter/all-status "全てのステータス"
   :filter/all-tags "全てのタグ"

   :user "ユーザー"
   :users "ユーザー"
   :staff "スタッフ"
   :staffs "スタッフ"
   :directory "ディレクトリ"
   :user/name "名前"
   :user/external-id "職員番号"
   :user/title "役職名称"
   :user/space "ブティック"
   :user/role "アカウント権限"
   :user/team "チーム"
   :user/reportTo "Report to"
   :user/isTemporary "OMS"
   :user/locale "言語"
   :user/spokenLanguages "追加言語"
   :user/email "Eメール"
   :user/password "パスワード"
   :user/shiftPreferences "シフト設定"
   :shift-preferences/description "曜日ごとの優先シフト。"

   :role/permissions "権限"

   :space "ブティック"
   :space/name "ブティック名"
   :space/nameJp "ブティック名（日本語）"
   :space/boutiqueId "ブティックID"
   :space/active "アクティブ"

   :team "チーム"
   :team/color "色"
   :team/name "チーム名"
   :team/members "メンバー"

   :schedule "予定"
   :event "イベント"
   :events "イベント"
   :company-events "カンパニー イベント"
   :boutique-events "ブティック イベント"
   :event/title "タイトル"
   :event/calendar "カレンダー"
   :event/isAllDay "終日"
   :event/start "開始時間"
   :event/end "終了時間"
   :event/location "場所"
   :event/url "URL"
   :event/status "ステータス"
   :event/organizer "主催者"
   :event/attendees "出席者"
   :event/participants "参加者"
   :event/no-attendees "出席者なし"
   :event/tags "タグ"
   :event/name "イベント名（英語）"
   :event/nameJp "イベント名"
   :event/description "備考"
   :event/floorplan-url "Floorplan URL"
   :event.status/pending "未確認"
   :event.status/declined "不可"
   :event.status/accepted "可"
   :event.status/switched "代理"

   :shift "シフト"
   :shifts "シフト"
   :shift/pattern "シフトパターン"
   :shift/patterns "シフトパターン"
   :shift/tag "シフトタグ"
   :shift/tags "シフトタグ"
   :shift/comment "コメント"
   :shift/total-hours "合計勤務時間"
   :shift/hours-difference "時間差"
   :shift/weekends-weekdays-ratio "土日祝・平日"
   :shift/work-days "勤務日数"
   :shift/available-sales-staffs "販売可能スタッフ数"
   :shift/total-staffs "総人数"
   :shift/counts "カウント数"

   :shift/formula "シフト式"
   :shift.formula/symbol "表記"
   :shift.formula/color "色"
   :shift.formula/patterns "シフトパターン"
   :shift.formula/teams "チーム"
   :shift.formula/users "社員"
   :shift.formula/filters "フィルタ"

   :shift-pattern/symbol "表記(1文字)"
   :shift-pattern/startTime "開始時間"
   :shift-pattern/endTime "終了時間"
   :shift-pattern/hours "時間"
   :shift-pattern/description "備考"
   :shift-pattern/isDayOff "公休 ON / OFF"
   :shift-tag/color "色"
   :shift-tag/symbol "表記(1文字)"

   :shift-tag/description "備考"

   :room "ルーム"
   :rooms "ルーム"
   :room/name "ルーム名"
   :room/nameJp "ルーム名"
   :room/color "色"
   :room/status "Status"
   :room/type "ルームタイプ"
   :room/coordinates "Coordinates"
   :room/description "備考"

   :room.status/occupied "使用中"
   :room.status/busy "使用中"
   :room.status/free "空"
   :room.status/assigned "割当済"
   :room.status/cleaning-needed "掃除必要"
   :room.status/cleaned "掃除済み"

   :room/previous-booking-still-ongoing "以前の予約がまだ進行中です"
   :room/cleaning-needed-from-previous-booking "前回の予約で掃除が必要"

   :booking "予約"
   :booking/inviter "担当者名"
   :booking/guest "顧客"
   :booking/guestFirstName "メイ"
   :booking/guestLastName "セイ"
   :booking/guestFirstNameJp "名"
   :booking/guestLastNameJp "姓"
   :booking/productName "予約商品名"
   :booking/externalId "管理番号"
   :booking/bookingId "予約コード"
   :booking/guestId "顧客ID"
   :booking/guestNumbers "人数"
   :booking/roomType "ルームタイプ"
   :booking/accompanyingGuests "お連れ様"
   :booking/boutiqueName "BTQ名"
   :booking/inviterName "BTQ担当者名"
   :booking/guest1Name "お連れ様(1）カナ"
   :booking/guest1NameJp "お連れ様(1）氏名（姓　名)"
   :booking/guest1Gender "お連れ様(1）性別"
   :booking/guest1Age "お連れ様(1）年齢"
   :booking/guest2Name "Guest 2 Name"
   :booking/guest2NameJp "Guest 2 Name (Jp)"
   :booking/guest2Age "Guest 2 Age"
   :booking/comment "お客様情報備考"
   :booking/start "開始時間"
   :booking/end "終了時間"
   :booking/date "日付"
   :booking/time "時間"
   :booking/no-accompanying-guests-information "お連れ様の情報がありません"
   :booking/no-room-assigned "部屋が割り当てられていません"
   :booking/not-checked-in "チェックインしていません"
   :booking/status "予約状況"
   :booking/cancelled "キャンセルされました"
   :booking.status/check-in "チェックイン"
   :booking.status/check-out "チェックアウト"
   :booking.status/arrived "到着"
   :booking.status/enter "入室" ;; = assigned
   :booking.status/assigned "部屋割当済" ;; = enter
   :booking.status/exit "退室"
   :booking.status/cleaned "掃除済"
   :booking.status/left "退場"
   :booking.status/check-in-time "チェックイン時間"
   :booking.status/arrived-time "到着時間"
   :booking.status/enter-time "割当済時間" ;; 入室
   :booking.status/exit-time "退室時間"
   :booking.status/cleaned-time "掃除済時間"
   :booking.status/left-time "退場時間"
   :booking.status/check-out-time "チェックアウト時間"

   :attendance "本日の予定"})
